import store, { useRecoilState } from '@store';

export const useSelectedPlan = ({ selectedVariant }) => {
  return useRecoilState(store.selectedPlan(selectedVariant?.id));
};
